exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form.form-calification{width:250px;margin:0 auto;height:20px}#form p.calification{text-align:center;font-size:3em}#form .calification label{font-size:5em!important}.calification label,.gray{color:grey}.orange{color:orange!important}", ""]);

// exports
